<template>
  <template v-if="editableMode">
    <tr class="font-bold">
      <td class="align-middle px-2 text-center border-r border-t-8" rowspan="4" />
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Item
      </th>
      <th class="px-6 py-2 w-2/12 text-left border-r border-t-8">
        Unit
      </th>
      <th class="px-6 py-2 w-2/12 text-right border-r border-t-8">
        Quantity
      </th>
      <th class="px-6 py-2 w-2/12 text-right border-r border-t-8">
        Harga Est
      </th>
      <th class="px-6 py-2 w-2/12 text-right border-r border-t-8">
        Subtotal
      </th>
      <td
        v-if="!disabled"
        class="py-2 border-l border-t-8"
        rowspan="4">
        <div class="flex items-center px-6 py-4">
          <button
            class="btn-blue"
            @click="store"
            :disabled="itemTypeLoading"
            :class="{ 'opacity-50 cursor-not-allowed': itemTypeLoading }">
            Save
          </button>
          <button class="btn-red ml-2" @click="cancel">
            Cancel
          </button>
        </div>
      </td>
    </tr>
    <tr>
      <td class="border-r border-t">
        <vSelect
          v-model="detail.item"
          class="focus:text-indigo-500"
          :class="{ error: errors.item_id }"
          placeholder="[Pick Item...]"
          label="name"
          :filterable="false"
          :options="options"
          :append-to-body="true"
          @search="onSearch" />
        <div v-if="errors.item_id" class="form-error whitespace-normal">
          {{ errors.item_id }}
        </div>
      </td>
      <td class="border-r border-t">
        <vSelect
          v-model="detail.item_unit"
          label="name"
          placeholder="[Pick Unit...]"
          :class="{ error: errors.item_unit_id }"
          :options="unitOptions"
          :append-to-body="true"
          @option:selected="setSelectedUnit" />
        <div v-if="errors.item_unit_id" class="form-error -py-4 px-3 whitespace-normal">
          {{ errors.item_unit_id }}
        </div>
      </td>
      <td class="text-right border-r border-t">
        <div class="text-right">
          <number-input
            v-model="detail.item_qty"
            class=""
            :error="errors.item_qty" />
        </div>
      </td>
      <td class="text-right border-b border-r border-t">
        <div class="text-right">
          <number-input
            v-model="detail.item_unit_price_est"
            class=""
            :error="errors.item_unit_price_est" />
        </div>
      </td>
      <td class="text-right border-b border-r border-t">
        <div class="text-right">
          <text-input
            :model-value="formatNumber(subtotal)"
            class="text-right"
            input-class="text-right"
            readonly />
        </div>
      </td>
    </tr>
    <tr>
      <th class="px-6 py-2 text-left border-r border-t">
        Specs
      </th>
      <th class="px-6 py-2 text-left border-r border-t">
        Item Type
      </th>
      <th class="px-6 py-2 text-right border-r border-t">
        Harga Hist
      </th>
    </tr>
    <tr>
      <td class="align-top border-r border-t">
        <textarea-input v-model="detail.specs" :error="errors.specs" />
      </td>
      <td class="align-top border-r border-t">
        <text-input
          :model-value="detail.item_type"
          input-class="max-w-sm"
          readonly />
      </td>
      <td class="align-top border-r border-t">
        <text-input
          :model-value="formatNumber(requestDetail.item_unit_price_hist)"
          input-class="text-right"
          disabled />
      </td>
    </tr>
  </template>
  <template v-else>
    <tr class="font-bold">
      <td class="align-middle px-2 text-center border-r border-t-8" rowspan="4">
        {{ rowIndex }}.
      </td>
      <th class="px-6 py-2 w-4/12 text-left border-r border-t-8">
        Item
      </th>
      <th class="px-6 py-2 w-2/12 text-left border-r border-t-8">
        Unit
      </th>
      <th class="px-6 py-2 w-2/12 text-right border-r border-t-8">
        Quantity
      </th>
      <th class="px-6 py-2 w-2/12 text-right border-r border-t-8">
        Harga Est
      </th>
      <th class="px-6 py-2 w-2/12 text-right border-r border-t-8">
        Subtotal
      </th>
      <td
        v-if="!disabled"
        class="py-2 border-l border-t-8"
        rowspan="4">
        <div class="flex items-center px-6 py-4">
          <button title="Edit Detail" @click="edit">
            <Icon icon="ic:baseline-edit-note" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Delete Detail" @click="destroy">
            <Icon icon="ic:baseline-delete" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </tr>
    <tr>
      <td class="border-r border-t">
        <div class="flex items-center px-6 focus:text-indigo-500">
          {{ requestDetail.item.name }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4">
          {{ requestDetail.item_unit.name }}
        </div>
      </td>
      <td class="text-right border-r border-t">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(requestDetail.item_qty) }}
        </div>
      </td>
      <td class="text-right border-b border-r border-t">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(requestDetail.item_unit_price_est) }}
        </div>
      </td>
      <td class="text-right border-b border-r border-t">
        <div class="text-rigt px-6 py-4">
          {{ formatNumber(requestDetail.subtotal) }}
        </div>
      </td>
    </tr>
    <tr>
      <th class="px-6 py-2 text-left border-r border-t">
        Specs
      </th>
      <th class="px-6 py-2 text-left border-r border-t">
        Item Type
      </th>
      <th class="px-6 py-2 text-right border-r border-t">
        Harga Hist
      </th>
    </tr>
    <tr>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4 focus:text-indigo-500 whitespace-pre-line">
          {{ requestDetail.specs }}
        </div>
      </td>
      <td class="border-r border-t">
        <div class="flex items-center px-6 py-4">
          {{ requestDetail.item_type }}
        </div>
      </td>
      <td class="text-right border-r border-t">
        <div class="px-6 py-4 text-right">
          {{ formatNumber(requestDetail.item_unit_price_hist) }}
        </div>
      </td>
    </tr>
  </template>
</template>

<script lang="js">
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import vSelect from 'vue-select'
import NumberInput from '@/Shared/NumberInput'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import 'vue-select/dist/vue-select.css'
import throttle from 'lodash/throttle'
import clone from 'lodash/clone'

export default {
    components: {
        Icon,
        vSelect,
        NumberInput,
        TextInput,
        TextareaInput,
    },
    props: {
        requestDetail: Object,
        units: Object,
        errors: Object,
        editableMode: {
            type: Boolean,
            default: false,
        },
        rowIndex: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['destroy:detail', 'cancel', 'save', 'edit:detail'],
    setup (props) {
        const options = ref(props.requestDetail.item ? [{ id: props.requestDetail.item.id, name: props.requestDetail.item.name }] : [])
        const detail = ref(props.requestDetail)
        const itemTypeLoading = ref(false)
        const oriData = ref(props.requestDetail.id ? clone(props.requestDetail) : {
            id: null,
            item: null,
            item_unit: null,
            item_qty: 0,
            item_unit_price_hist: 0,
            item_unit_price_est: 0,
            specs: null,
            editable: false,
        })
        const search = throttle((loading, search) => {
            fetch(`/items?options=1&search=${escape(search)}`).then((res) => {
                res.json().then((json) => (options.value = json.items))
                loading(false)
            })
        }, 500)
        const unitOptions = ref(props.requestDetail.item_unit ? [props.requestDetail.item_unit] : [])

        return {
            search,
            options,
            detail,
            oriData,
            unitOptions,
            itemTypeLoading,
        }
    },
    computed: {
        subtotal () {
            return (this.detail.item_qty * this.detail.item_unit_price_est) ?? 0
        },
    },
    watch: {
        'detail.item' (newVal) {
            if (newVal) {
                this.getItemType(newVal.id)
                this.detail.item_unit = null
                this.unitOptions = newVal.units ? this.units.filter(i => newVal.units.includes(i.id)) : []
                this.detail.item_unit_price_hist = 0
            }
        },
    },
    methods: {
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
        setSelectedUnit (item_unit) {
            this.getItemPriceHistory(this.detail.item.id, item_unit.id)
        },
        onSearch (search, loading) {
            if (search.length) {
                loading(true)
                this.search(loading, search)
            }
        },
        edit () {
            this.oriData = clone(this.requestDetail)
            this.$emit('edit:detail', this.detail)
        },
        cancel () {
            this.detail = clone(this.oriData)
            this.$emit('cancel')
        },
        store () {
            if (this.itemTypeLoading || !this.detail.item_type) {
                alert('Please wait for item type to load or select an item first')
                return
            }
            this.$emit('save', this.detail)
        },
        destroy () {
            if (confirm('Are you sure you want to delete this details?')) {
                this.$emit('destroy:detail', this.requestDetail.id)
            }
        },
        getItemType (itemId) {
            this.itemTypeLoading = true
            fetch(`/itemtype?item=${itemId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    this.detail.item_type = data.data.type
                })
                .finally(() => {
                    this.itemTypeLoading = false
                })
        },
        getItemPriceHistory (itemId, unitId) {
            fetch(`/itempricehist?item=${itemId}&unit=${unitId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    this.detail.item_unit_price_hist = data.last_price
                })
        },
    },
}
</script>

<style scoped>
.v-select {
  --vs-line-height: 1.9;
}
</style>
